import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { CommonService } from 'src/app/providers/common.service';
import { isEqual } from 'lodash';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-merchant-contract',
  templateUrl: './merchant-contract.component.html',
  styleUrls: ['./merchant-contract.component.scss']
})
export class MerchantContractComponent implements OnInit {
  @Output() contractForm = new EventEmitter<any>();
  @Output() contractLoaderFn = new EventEmitter<any>();
  public contractLoader: boolean = true;
  public standardBillingTemplate!: FormGroup;
  public template: any = {};
  public standardBillingIndex: number[];
  private orginalTemplate: any = {};
  public valueAddedServiceTemplate!: FormGroup;
  public changedSections: string[] = [];
  public queryParams: any = this.activeRoute.snapshot.queryParams;
  public from: string = this.queryParams.from;
  @Input() merchantId: string;
  @Input() disable: Boolean;
  constructor(
    private common: CommonService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private activeRoute: ActivatedRoute


  ) { }

  ngOnInit(): void {
    this.getContract();
  }
  getContract = () => {
    this.contractLoaderFn.emit('true');
    let param = {};
    if(this.merchantId){
      param['merchantId'] = this.merchantId
    }
    this.common.getCommonHttpClientQueryParams(apiLinks.merchantBilling.getContract,param).pipe(take(1)).subscribe((res: any) => {
      this.contractLoader = false;
      this.contractLoaderFn.emit('false');
      this.template = res.templateJson;
      this.generateFormFn();
    }, (error) => {
      // this.contractLoader = false;
      this.contractLoaderFn.emit('error');
      this.showToaster('error', '', error.message);
    })
  }
  generateFormFn = () => {
    const buildFormGroup = (template: any[]) => {
      const group: { [key: string]: FormGroup } = {};

      template.forEach(section => {
        const sectionGroup = this.fb.group({});

        section.fields.forEach(field => {
          const controlValidators: ValidatorFn[] = [];

          field.validations?.forEach(val => {
            switch (val.validator) {
              case 'required':
                controlValidators.push(Validators.required);
                break;
              case 'min':
                controlValidators.push(Validators.min(val.value));
                break;
              case 'max':
                controlValidators.push(Validators.max(val.value));
                break;
              case 'pattern':
                controlValidators.push(Validators.pattern(val.value));
                break;
            }
          });

          sectionGroup.addControl(
            field.name,
            this.fb.control(field.value, {
              validators: controlValidators,
              updateOn: 'change'
            })
          );
        });

        group[section.code] = sectionGroup;
      });

      return group;
    }

    this.standardBillingTemplate = this.fb.group(buildFormGroup(this.template.standardBillingTemplate));
    this.valueAddedServiceTemplate = this.fb.group(buildFormGroup(this.template.valueAddedServiceTemplate));
    this.orginalTemplate = {
      standardBillingTemplate: this.standardBillingTemplate.value,
      valueAddedServiceTemplate: this.valueAddedServiceTemplate.value,
    };
    this.standardBillingIndex = [];
    this.template.standardBillingTemplate.map((_, i: any) => {
      this.standardBillingIndex.push(i);
    })
     if (this.disable) {
      this.standardBillingTemplate.disable();
      this.valueAddedServiceTemplate.disable();
    }
    this.standardBillingTemplate.markAllAsTouched();
    this.valueAddedServiceTemplate.markAllAsTouched();
    this.emitFn();
  }

  public isSectionChanged(group: string, code?: string): boolean {
    if (group == 'standardBillingTemplate') {
      return !isEqual(this.standardBillingTemplate.value[code], this.orginalTemplate.standardBillingTemplate[code])
    }
    if (group == 'valueAddedServiceTemplate') {
      return !isEqual(this.valueAddedServiceTemplate.value, this.orginalTemplate.valueAddedServiceTemplate)
    }
  }

  emitFn = () => {
    const value = {
      standardBillingTemplate: this.standardBillingTemplate.getRawValue(),
      valueAddedServiceTemplate: this.valueAddedServiceTemplate.getRawValue()
    };
    if (this.standardBillingTemplate.invalid || this.valueAddedServiceTemplate.invalid) {
      this.contractForm.emit({ invalid: true, value: {} });
      return;
    }

    this.contractForm.emit({
      valid: true,
      value,
      changedValue: this.diff(this.orginalTemplate, value),
      isChanged: !isEqual(this.orginalTemplate, value)
    })
  }
  showToaster(type, define, message) {
    this.messageService.add({
      severity: type,
      summary: define,
      detail: message,
      key: 'copy-toast'
    });
  }

  onInputFn(newValue: number, sectionCode: string, controlName: string, group: FormGroup) {
    const control = group
      .get(sectionCode)!
      .get(controlName)!;

    control.setValue(newValue, {
      emitEvent: true,
      onlySelf: true
    });
    control.markAsDirty();
    control.updateValueAndValidity();
    this.emitFn();
  }
  private diff = (o: any, c: any): any =>
    Object.entries(c).reduce((acc, [k, v]) => {
      const ov = o?.[k];
      if (v && typeof v === 'object' && !Array.isArray(v)) {
        const d = this.diff(ov || {}, v);
        if (Object.keys(d).length) acc[k] = d;
      } else if (v !== ov) {
        acc[k] = v;
      }
      return acc;
    }, {} as any);
}
